<template>
  <div>
    <v-dialog
        v-model="localDialogStatus"
        persistent
        max-width="900px"
    >
      <v-card class="sms-preview-card">

        <!-- Header -->
        <v-card-title class="sms-header">
          <div class="d-flex align-center">
            <v-icon color="white" class="ml-2">mdi-message-text-outline</v-icon>
            <span class="white--text font-weight-bold">پیش‌نمایش ارسال پیام</span>
          </div>

          <v-spacer/>

          <div class="white--text text-caption">
            تاریخ:
            <span class="font-weight-bold">{{ date }}</span>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="pa-3">

          <v-row>
            <!-- Message preview -->
            <v-col cols="12" md="6">
              <v-card outlined class="preview-box">
                <v-card-title class="section-title">
                  <v-icon small color="primary" class="ml-1">mdi-eye-outline</v-icon>
                  متن پیامک
                </v-card-title>

                <v-divider/>

                <v-card-text id="style-1" style="height: 250px;overflow: auto">
                  <div
                      v-if="previewText"
                      class="message-preview"
                  >
                    {{ previewText }}
                    <div class="sms-count-container">
    <span class="sms-count-badge">
       تعداد پیامک: {{ messageStats.smsCount }}
    </span>
                    </div>
                  </div>

                  <div
                      v-else
                      class="empty-message"
                  >
                    متنی برای نمایش وجود ندارد.
                  </div>
                </v-card-text>
              </v-card>


            </v-col>

            <!-- Receivers list -->
            <v-col cols="12" md="6">
              <v-card outlined class="receiver-box">
                <v-card-title class="section-title">
                  <v-icon small color="primary" class="ml-1">mdi-account-multiple-outline</v-icon>
                  لیست گیرنده‌ها

                  <v-spacer/>

                  <v-chip small color="primary" label>
                    {{ receiverCount }} نفر
                  </v-chip>
                </v-card-title>

                <v-divider/>

                <v-card-text class="receiver-list" id="style-1" style="height: 250px;overflow: auto">
                  <template v-if="receivers.length">
                    <v-list dense two-line>
                      <v-list-item
                          v-for="(item, index) in receivers"
                          :key="index"
                          class="receiver-item"
                      >
<!--                        <v-list-item-avatar size="30" color="error lighten-5">-->
<!--                          <v-icon color="primary">mdi-account</v-icon>-->
                          <v-icon color="error" class="mx-1" @click.stop="removeReceiver(index)">mdi-account-minus</v-icon>
<!--                        </v-list-item-avatar>-->


                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ item.text || 'بدون نام' }}
                          </v-list-item-title>

                          <v-list-item-subtitle dir="ltr" class="text-left">
                            {{ item.value || '-' }}
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-chip
                              x-small
                              :color="item.value1 === 'OWNER' ? 'blue lighten-4' : 'green lighten-4'"
                              :text-color="item.value1 === 'OWNER' ? 'blue darken-3' : 'green darken-3'"
                          >
                            {{ getRoleTitle(item.value1) }}
                          </v-chip>

                        </v-list-item-action>

                      </v-list-item>
                    </v-list>
                  </template>

                  <div v-else class="empty-receiver">
                    <v-icon color="grey">mdi-account-off-outline</v-icon>
                    <div class="mt-2">گیرنده‌ای انتخاب نشده است.</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Cost summary -->
          <v-card outlined class="mt-4 cost-box">
            <v-row align="center">
              <v-col cols="12" sm="3">
                <div class="cost-label">اعتبار فعلی</div>
                <div class="cost-value success--text">
                  {{ formatPrice(creditBalance) }}
                </div>
              </v-col>

              <v-col cols="12" sm="3">
                <div class="cost-label">هزینه هر پیامک</div>
                <div class="cost-value">
                  {{ formatPrice(cost) }}
                </div>
              </v-col>

              <v-col cols="12" sm="3">
                <div class="cost-label">هزینه هر نفر</div>
                <div class="cost-value">
                  {{ formatPrice(costPerReceiver) }}
                </div>
              </v-col>

              <v-col cols="12" sm="3">
                <div class="cost-label">هزینه کل</div>
                <div
                    class="cost-value"
                    :class="hasEnoughCredit ? 'primary--text' : 'error--text'"
                >
                  {{ formatPrice(totalCost) }}
                </div>
              </v-col>
            </v-row>
          </v-card>

        </v-card-text>

        <!-- Actions -->
        <v-divider/>

        <v-card-actions dir="ltr" class="pa-4">
          <v-btn
              color="primary"
              depressed
              :disabled="!canSend"
              :loading="loading"
              @click="sendSms"
          >
            ارسال پیامک
          </v-btn>
          <v-btn

              class="mx-2"
              color="error"
              @click="closed"
          >
            انصراف
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Low credit dialog -->
    <v-dialog
        v-model="lowCreditDialog"
        max-width="430px"
        persistent
    >
      <v-card>
        <v-card-title class="error white--text">
          <v-icon color="white" class="ml-2">mdi-alert-circle-outline</v-icon>
          اعتبار کافی نیست
        </v-card-title>

        <v-card-text class="pa-5">
          <div class="text-body-2 mb-3">
            اعتبار شما برای ارسال این پیامک کافی نیست.
          </div>

          <v-alert
              dense
              outlined
              type="error"
          >
            هزینه کل:
            <strong>{{ formatPrice(totalCost) }}</strong>
            <br/>
            اعتبار فعلی:
            <strong>{{ formatPrice(creditBalance) }}</strong>
          </v-alert>

          <div class="text-caption grey--text text--darken-1">
            برای ادامه ارسال، لطفاً حساب خود را شارژ کنید.
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-btn
              text
              color="grey"
              @click="lowCreditDialog = false"
          >
            بستن
          </v-btn>

          <v-spacer/>

          <v-btn
              color="success"
              depressed
              @click="goToPayment"
          >
            <v-icon small class="ml-1">mdi-credit-card-outline</v-icon>
            پرداخت و شارژ حساب
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Service_se from "@/views/reporting/remainingReport/Service";

export default {
  props: {
    dialogStatus: {
      default: false,
    },
    model: {
      type: Object,
      default: () => ({})
    },
    creditBalance: {
      type: Number,
      default: 0
    },
    cost: {
      type: Number,
      default: 0
    },
    previewText: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      lowCreditDialog: false
    };
  },

  computed: {
    localDialogStatus: {
      get() {
        return this.dialogStatus;
      },
      set(value) {
        this.$emit('update:dialogStatus', value);
      }
    },

    receivers() {
      return this.model && this.model.receiverItem
          ? this.model.receiverItem
          : [];
    },

    receiverCount() {
      return this.receivers.length;
    },

    messageStats() {
      const message = this.previewText || '';
      const length = message.length;

      let smsCount = 0;

      if (length > 0) {
        if (length <= 70) {
          smsCount = 1;
        } else {
          smsCount = Math.ceil((length - 70) / 67) + 1;
        }
      }

      return {
        length,
        smsCount
      };
    },

    costPerReceiver() {
      return this.messageStats.smsCount * this.cost;
    },

    totalCost() {
      return this.receiverCount * this.costPerReceiver;
    },

    hasEnoughCredit() {
      return this.creditBalance >= this.totalCost;
    },

    canSend() {
      return this.previewText &&
          this.receiverCount > 0 &&
          this.messageStats.smsCount > 0 &&
          !this.loading;
    }
  },

  methods: {
    sendSms() {
      if (!this.hasEnoughCredit) {
        this.lowCreditDialog = true;
        return;
      }

      this.loading = true;

      Service_se.sendMap(this.model)
          .then(response => {
            if (response && response.status === 200) {
              this.$snack({type: 'success', message: 'پیامک با موفقیت ارسال شد'});
              this.closed();
            }
          })
          .catch(() => {
            this.$snack({type: 'error', message: 'خطا در ارسال پیامک'});
          })
          .finally(() => {
            this.loading = false;
          });
    },
    removeReceiver(index) {
      this.$confirm("آیا از حذف این شخص از لیست گیرندگان مطمئن هستید؟","توجه",{color:"error"})
          .then(isConfirmed => {
            if (isConfirmed) {
              this.receivers.splice(index, 1);
            }
          });
    },
    closed() {
      this.$root.$emit("resetDialogsPreviewSms");
      this.$emit('update:dialogStatus', false);

    },

    goToPayment() {
      this.$root.$emit("reset_all_dialogs_sms");
      this.lowCreditDialog = false;
      this.$router.push({name: 'smsManager'});

      /**
       * یا اگر می‌خواهی parent مدیریت کند:
       * this.$emit('payment');
       */
    },

    formatPrice(value) {
      const number = Number(value || 0);

      return number.toLocaleString('fa-IR') + ' ریال ';
    },

    getRoleTitle(role) {
      if (role === 'OWNER') return 'مالک';
      if (role === 'TENANT') return 'مستاجر';
      return 'کاربر';
    }
  }
};
</script>

<style scoped>
.sms-preview-card {
  border-radius: 14px;
  overflow: hidden;
}

.sms-header {
  background: linear-gradient(135deg, #1976d2, #0d47a1);
  min-height: 64px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  padding: 6px 8px;
}

.preview-box,
.receiver-box,
.cost-box {
  border-radius: 12px;
}

.sms-count-container {
  position: absolute;
  bottom: 10px;
  left: 10px; /* چسباندن به سمت چپ */
  direction: rtl;
}

.sms-count-badge {
  background-color: #eceff1; /* خاکستری خیلی روشن */
  color: #546e7a;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: bold;
  border: 1px solid #cfd8dc;
}

.message-preview {
  min-height: 210px;
  max-height: 310px;
  overflow-y: auto;
  white-space: pre-line;
  line-height: 2;
  font-size: 15px;
  color: #222;
  background: #fafafa;
  border: 1px dashed #d5d5d5;
  border-radius: 10px;
  padding: 16px;
  position: relative;
  padding-bottom: 40px;
}

.empty-message {
  min-height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #fafafa;
  border: 1px dashed #ddd;
  border-radius: 10px;
}

.receiver-list {
  height: 360px;
  overflow-y: auto;
  padding: 8px !important;
}

.receiver-item {
  border-radius: 10px;
  margin-bottom: 4px;
}

.receiver-item:hover {
  background: #f5f7fa;
}

.empty-receiver {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
}

.cost-box {
  padding: 8px;
  background: #fbfbfb;
}

.cost-label {
  font-size: 12px;
  color: #777;
  margin-bottom: 6px;
}

.cost-value {
  font-size: 16px;
  font-weight: bold;
}

/* اگر پروژه RTL است، این کمک می‌کند ظاهر درست‌تر شود */
.sms-preview-card {
  direction: rtl;
}
</style>
